import { render } from "./AttivitaDet.vue?vue&type=template&id=69b92820"
import script from "./AttivitaDet.vue?vue&type=script&lang=js"
export * from "./AttivitaDet.vue?vue&type=script&lang=js"

import exportComponent from "D:\\documenti\\Lavoro\\Niemit\\com.niemit.cortebenedetto\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__